import React, { useEffect } from "react";
import "./styles.css";

const formatTime = (time: string) => {
    const date = new Date(time);
    if (date.getHours() == 21) {
        return "";
    }
    return date.getHours() + ":" + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ' - ';
};

const getDescription = (fullDescription: string): any => {
    const description = fullDescription ? fullDescription.split(">") : "";
    return description;
};

const EventDisplay = (props: any) => {
    const [tag, description] = getDescription(props.event.extendedProps.description);
    
    return (
        <div className={"eventDisplay " + tag}>
            <div>
                {formatTime(props.event.startStr)}{props.event.title}
            </div>
        </div>
    );
};

export default EventDisplay;
